import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import * as RegexPattern from '@teem/constants/regex-patterns';

@Component({
  selector: 'proposal-project-detail',
  templateUrl: './project-detail.component.html',
  styles: []
})
export class ProjectDetailComponent implements OnInit {
  @Output() triggerPrevious: EventEmitter<any> = new EventEmitter();
  @Output() onComplete: EventEmitter<any> = new EventEmitter();
  submitted: boolean = false;
  projectDetailForm: FormGroup;
  inspirationLinkForm: FormGroup;
  links: Array<string> = [];
  linkSubmitted: boolean = false;
  files: Array<File> = [];

  constructor(
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.projectDetailForm = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      comments: ['']
    })

    this.inspirationLinkForm = this.fb.group({
      link: ['', [Validators.required, Validators.pattern(RegexPattern.url_without_http)]]
    })
  }

  handleFileInput(files: FileList) {
    this.files = this.files.concat(Object.values(files));
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
  }

  submit() {
    this.submitted = true;

    if (this.projectDetailForm.valid) {
      let fd = this.projectDetailForm.value;

      if (this.links && this.links.length)
        fd.links = this.links;

      if (this.files && this.files.length)
        fd.new_files = this.files;

      this.onComplete.emit(fd);
    }
  }

  addLink() {
    this.linkSubmitted = true;
    if (this.inspirationLinkForm.valid) {
      let link = this.inspirationLinkForm.get('link').value;

      if (!RegexPattern.http_check.test(link)) {
        link = "http://" + link;
      }

      this.links.push(link);
      this.linkSubmitted = false;
      this.inspirationLinkForm.reset();
    }
  }

  removeLink(i: number) {
    this.links.splice(i, 1);
  }

}
